import { render, staticRenderFns } from "./BrowserStates.vue?vue&type=template&id=5afa17d7"
import script from "./BrowserStates.vue?vue&type=script&lang=js"
export * from "./BrowserStates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports